<div class="container">
  <div class="selected">
    <div *ngIf="isLoading" style="margin-top: 200px" class="spinner">
      <mat-spinner></mat-spinner>
    </div>
    <table *ngIf="!isLoading" style="width: 100%">
      <tr class="back">
        <th>
          <button
            class="create"
            mat-raised-button
            color="primary"
            [matMenuTriggerFor]="menu"
          >
            More
          </button>

          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="markAll()">
              Colect All Samples
            </button>
            <button mat-menu-item [disabled]="disable" (click)="collectAll()">
              Collect Selected
            </button>
            <button mat-menu-item [matMenuTriggerFor]="bar">Barcode</button>
          </mat-menu>
        </th>
        <th>Lab ID</th>
        <th>Collected</th>
        <th>Service</th>
        <th>Name</th>
        <th></th>
      </tr>
      <tr class="td" *ngFor="let item of edit" style="cursor: pointer">
        <td style="position: relative">
          <input
            type="checkbox"
            [checked]="item.selected"
            (change)="check(item, $event)"
          />
        </td>
        <td>{{ item.bill_id }}</td>
        <td *ngIf="item.sample_collected == 'N'">
          {{ item.sample_collected }}
        </td>
        <td *ngIf="item.sample_collected == 'Y'">
          <img
            style="width: 30px; height: 30px"
            src="assets/icons/done.gif"
            alt=""
          />
        </td>
        <td *ngIf="item.sample_collected == 'N'">{{ item.service_name }}</td>
        <td
          style="background-color: red; color: white"
          *ngIf="item.sample_collected == 'Y'"
        >
          {{ item.service_name }}
        </td>
        <td>{{ item.patient_name }}</td>
        <td>
          <button
            style="width: 80px"
            (click)="onSubmit(item)"
            mat-raised-button
            color="primary"
          >
            Collect
          </button>
        </td>
      </tr>
    </table>
  </div>
</div>
<mat-menu #bar="matMenu">
  <span class="input">
    <!-- <mat-form-field>
      <mat-label>Sub Department</mat-label>
      <mat-select
        [(ngModel)]="sub_dept_code"
        (selectionChange)="sub($event)"
        matNativeControl
      >
        <mat-option *ngFor="let dept of subDepts" [value]="dept.id">
          {{ dept.name }}
        </mat-option>
      </mat-select>
    </mat-form-field> -->
    <mat-form-field>
      <mat-label>Department</mat-label>
      <mat-select
        [(ngModel)]="dept_code"
        (selectionChange)="sub($event)"
        matNativeControl
      >
        <mat-option *ngFor="let dept of depts" [value]="dept.id">
          {{ dept.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </span>
</mat-menu>

<div class="barDetails" *ngIf="barVisile">
  <div class="all">
    <span class="input">
      <button
        style="margin-bottom: 20px"
        (click)="print()"
        mat-raised-button
        color="primary"
      >
        Print
      </button>
    </span>
    <div style="display: block" id="print-section">
      <b
        ><span style="font-size: 10px"
          ><b>Dept :</b> {{ barMessage.data[0].dept_name }}
        </span></b
      >
      <b
        ><span style="font-size: 10px"
          ><b>Lab Id : </b>{{ data.bill_id }}
        </span></b
      >
      <b
        ><span style="font-size: 10px">
          <b>Patient Name : </b>{{ barMessage.data[0].patient_name }}</span
        ></b
      >
      <b
        ><span style="font-size: 10px">
          <b>Age :</b>{{ barMessage.data[0].patient_age }}
        </span></b
      >
      <b
        ><span style="font-size: 10px">
          <b>Gender : </b>{{ barMessage.data[0].patient_gender }}
        </span></b
      >
      <br />
      <b
        ><span style="font-size: 10px"><b>Date : </b>{{ date }}</span></b
      >
      <br />
      <img [src]="barMessage.data[0].barcode_data" alt="" /> <br />
    </div>
  </div>
</div>
